import { eachDayOfInterval } from 'date-fns';
import i18n from 'i18next';

export * from './trelloState';
export * from './labelColors';

/* eslint-disable */
export function uuidv4() {
  // $FlowFixMe
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    // $FlowFixMe
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}
/* eslint-enable */

export const pluralIntl = new Intl.PluralRules('en-US', { type: 'cardinal' });

export function pluralize(value, values) {
  return values[pluralIntl.select(value)];
}

export const delay = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export function getTimeString(seconds) {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const moreThanOneHour = hours >= 1;

  const secondsRelatedMinutes = minutes >= 1 ? seconds - minutes * 60 : seconds;
  const minutesRelatedHours = hours >= 1 ? minutes - hours * 60 : minutes;
  const minutesFormat =
    minutesRelatedHours >= 10
      ? minutesRelatedHours.toString()
      : `0${minutesRelatedHours}`;
  const secondsFormat =
    secondsRelatedMinutes >= 10
      ? secondsRelatedMinutes.toString()
      : `0${secondsRelatedMinutes}`;
  const hoursFormat = hours >= 10 ? hours.toString() : `0${hours}`;

  if (moreThanOneHour) {
    return `${hoursFormat}:${minutesFormat}:${secondsFormat}`;
  }
  return `${minutesFormat}:${secondsFormat}`;
}

export const capitalizeFirstLetter = (string) =>
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`;

export const scrollbarSize = (() => {
  const div1 = window.document.createElement('div');
  const div2 = window.document.createElement('div');

  div1.style.width = '100px';
  div1.style.overflowX = 'scroll';
  div2.style.width = '100px';

  if (!window.document.body) {
    return 0;
  }

  window.document.body.appendChild(div1);
  window.document.body.appendChild(div2);

  const size = div1.offsetHeight - div2.offsetHeight;

  window.document.body.removeChild(div1);
  window.document.body.removeChild(div2);

  return size;
})();

let lastSelected = null;

export const calculateCalendarSelection = (
  currentSelection,
  newDate,
  event
) => {
  const dateISO = newDate.toISOString();
  const isShiftDown = event.nativeEvent.shiftKey;

  if (isShiftDown && lastSelected) {
    const selectedDays = eachDayOfInterval({
      start: newDate > lastSelected ? lastSelected : newDate,
      end: newDate > lastSelected ? newDate : lastSelected,
    });
    return [...currentSelection, ...selectedDays];
  }
  lastSelected = newDate;

  const isDaySelected = currentSelection.some(
    (d) => d.toISOString() === dateISO
  );
  if (isDaySelected) {
    return currentSelection.filter((d) => d.toISOString() !== dateISO);
  }
  return [...currentSelection, newDate];
};

export function getWhoisTracking({ users, cardState, trackingIds }) {
  const trackingUserIds =
    trackingIds ||
    Object.keys(cardState)
      .filter(
        (stateKey) =>
          stateKey.includes('_state') &&
          ['run', 'pause'].includes(cardState[stateKey]?.timerStatus)
      )
      .map((stateKey) => stateKey.split('_')[0]);
  const nobodyTracking = !trackingUserIds.length;
  if (nobodyTracking) {
    return null;
  }

  // User may not exist on the board anymore
  const existUsers = trackingUserIds
    .map((userId) => users[userId])
    .filter(Boolean);
  if (!existUsers.length) {
    return null;
  }
  const onlyOneUser = existUsers.length === 1;
  if (onlyOneUser) {
    const [user] = existUsers;
    return i18n.t('trackingBar.oneUserIsWorking', {
      name: user.fullName,
    });
  }
  return [
    ...existUsers
      .map(({ fullName }, index) => {
        const isFirst = index === 0;
        const isLast = index === existUsers.length - 1;

        if (isFirst) {
          return fullName;
        }

        if (isLast) {
          return `${i18n.t('trackingBar.andUsersWorking')} ${fullName}`;
        }

        return `, ${fullName}`;
      })
      .concat(i18n.t('trackingBar.multiUsersAreWorking'))
      .join(' '),
  ].join('');
}

export const getMemberInitials = (fullName = 'Unknown User') => {
  let initials = fullName.split(' ');
  initials =
    initials.shift().charAt(0) +
    (initials.length ? initials.pop().charAt(0) : '');
  return initials.toUpperCase();
};

export const validateJiraTime = (value) =>
  /^(?:\d{1,}d{1}(?:\s{1}|$))?(?:\d{1,}h{1}(?:\s{1}|$))?(?:\d{1,}m{1}(?:\s{1}|$))?(?:\d{1,}s{1}(?:\s{1}|$))?$/.test(
    value
  );

export const isMobile = () =>
  [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ].some((toMatchItem) => navigator.userAgent.match(toMatchItem));

export function f(arg) {
  return (props) => {
    try {
      return arg.try(props);
    } catch (err) {
      return arg.catch(props, err);
    }
  };
}

export const captureAsyncThunkError = (_, action) => {
  throw new Error(action.error.stack);
};

export const getEstimatesWithUser = (estimates, usersEntities) =>
  estimates.map((estimate, index) => ({
    ...estimate,
    user: usersEntities[estimate.accountId] ?? {
      id: index,
      username: 'unknown',
      initials: 'UN',
      fullName: 'Unknown user',
      seconds: 0,
    },
  }));

export function isLocalStorageAvailable() {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

export function getLiveWorklogId(worklog) {
  return `${worklog.boardId}_${worklog.cardId}_${worklog.memberId}`;
}
